import * as React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { Login, Logout, RequireAuthentication, SilentRenew } from '@module/authentication';
import { default as LicenseContainer } from '@module/license/components/LicenseContainer';
import { default as RegisterSiteContainer } from '@module/registerSite/index';
import { Layout } from '@module/shared';
import { default as SitesContainer } from '@module/site/index';
import { UserManagement } from '@module/userManagement/index';

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout><Outlet /></Layout>}>
        <Route path='/login' element={<Login />} />
        <Route path='/logout' element={<Logout />} />
        <Route path='/SilentRenew' element={<SilentRenew />} />
        <Route element={<RequireAuthentication><Outlet /></RequireAuthentication>}>
          <Route path='/UserManagement' element={<UserManagement />} />
          <Route path='/register' element={<RegisterSiteContainer />} />
          <Route path='/Licenses/:siteId' element={<LicenseContainer />} />
          <Route path='/' element={<SitesContainer />} />
        </Route>
      </Route>
    </Routes>
  );
}
